import {clickEvent} from "../../../webpack/modules/events";

clickEvent('footer .social-link', false, function(element) {
    window.open(element.dataset.url);
});